import React from 'react'

export default function DeleteIcon (props) {
  return (
    <svg className={'deleteIcon'} viewBox='0 0 1024 1024' width={props.width || 200} height={props.height || 200} fill={props.color || '#8B8B8B'}>
      <path d='M512 472.66826911L367.84855732 328.484375a27.81129776 27.81129776 0 1 0-39.33173008 39.33173089L472.63581768 512l-144.18389492 144.15144268a27.81129776 27.81129776 0 1 0 39.3317309 39.33173008L512 551.36418232l144.15144268 144.18389492a27.81129776 27.81129776 0 1 0 39.33173008-39.3317309L551.36418232 512l144.18389492-144.15144268a27.81129776 27.81129776 0 1 0-39.3317309-39.33173008L512 472.63581768z' />
    </svg>
  )
}
